<div class="wrapper">
    <div class="avaliacoes-container">
        <h1>O que nossos clientes estão dizendo</h1>
        <p>Veja relatos sobre o que as pessoas têm a dizer do Forecast.</p>
    </div>
    
    <div class="avaliacoes-card-container">
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
        <app-avaliacoes-card />
    </div>
</div>